<template>
  <div class="col-lg-4 col-md-6 col-12 flip-container" @click="clickCard">
    <div class="flipper">
      <div class="front">
        <div class="person">
          <img :src="person.image">
          <span class="name">
            {{person.name}}
          </span>
          <span class="title">
            {{person.title}}
          </span>
          <span class="email">
            <a :href="'mailto:' + person.email">{{person.email}}</a>
          </span>
          <div class="social">
            <a v-for="service in services" v-bind:key="service.key"
            v-if="person[service.key]"
            :href="service.link + person[service.key]" target="_blank">
              <i :class="service.icon"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="back">
        <div class="person">
          <div class="header">
            <img :src="person.image">
            <div class="label">
              <span class="name">
                {{person.name}}
              </span>
              <span class="title">
                {{person.title}}
              </span>
            </div>
          </div>
          <div class="details">
            <div class="quote" v-if="person.quote">
              <span class="text">
                {{person.quote.text}}
              </span>
              <span class="author">
                {{person.quote.author}}
              </span>
            </div>
            <div class="story">
              {{person.story}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Card',
  props: [
    'person',
  ],
  methods: {
    clickCard: function clickCard() {
      this.$el.classList.toggle('clicked');
    },
  },
  data() {
    return {
      services: [
        {
          key: 'linkedin',
          link: 'https://linkedin.com/in/',
          icon: 'fab fa-linkedin',
        },
        {
          key: 'twitter',
          link: 'https://twitter.com/',
          icon: 'fab fa-twitter',
        },
        {
          key: 'instagram',
          link: 'https://instagram.com/',
          icon: 'fab fa-instagram',
        },
      ],
    };
  },
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.person {
  height: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  padding: 20px;

  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
}

.flip-container {
  perspective: 1000px;
  height: 480px;
}

/* flip the pane when clicked */
.flip-container.clicked .flipper {
  transform: rotateY(180deg);
}

.flip-container .front, .back {
  width: 100%;
  height: 100%;
}

/* flip speed goes here */
.flipper {
  height: 100%;
  transition: 0.6s;
  transform-style: preserve-3d;

  position: relative;
}

/* hide back of pane during swap */
.front, .back {
  backface-visibility: hidden;

  position: absolute;
  top: 0;
  left: 0;
}

/* front pane, placed above back */
.front {
  z-index: 2;
  transform: rotateY(0deg);

  .person {
    justify-content: center;

    * {
      align-self: center;
    }

    img {
      height: 200px;
      width: 200px;
      border-radius: 100px;
      object-fit: cover;
      object-position: top center;
      filter: #{"grayscale()"};
      transition: 0.3s;
    }

    .name {
      margin-top: 20px;
      font-weight: bold;
    }

    .social > a > i {
      color: #000;
      padding: 2px;
    }
  }

  .person:hover img {
    filter: none;
  }
}

/* back, initially hidden pane */
.back {
  transform: rotateY(180deg);

  .person {

    .header {
      display: flex;
      flex-direction: row;
      padding: 10px;
      height: 80px;

      .label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        padding-left: 10px;

        .name {
          font-weight: bold;
        }
      }

      img {
        height: 60px;
        width: 60px;
        border-radius: 30px;
        object-fit: cover;
        object-position: top center;
      }
    }

    .details {
      padding-top: 10px;

      .quote {
        display: flex;
        flex-direction: column;

        color: #ccc;
        quotes: "«" "»" "‹" "›";
        font-weight: 200;
        line-height: 1.2em;
        height: 4.8em;

        .text:before {
          content: open-quote;
          margin-right: 0.25em;
        }

        .text:after {
          content: close-quote;
          margin-left: 0.25em;
        }

        .author {
          font-weight: 500;
        }

        .author:before {
          content: "—";
        }
      }

      .story {
        padding-top: 10px;
        text-align: justify;
        word-break: break-word;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Card.vue